import { useForm, Form, Input, Row, Col, Edit, ListButton } from '@pankod/refine-antd';
import { ICategory } from 'interfaces';

export const CategoryEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<ICategory>({
    metaData: {
      fields: ['id', 'name', 'description'],
    },
  });

  return (
    <Edit
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
      headerProps={{ extra: <ListButton /> }}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
          ...formProps.initialValues,
        }}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={8} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
